import { useLocation, useNavigate } from 'react-router';

import { useAppSelector } from '~/hooks/redux';

export function useAuth() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { data: currentUser, isSignedIn } = useAppSelector(
    (state) => state.currentUser
  );

  function promptLogin(): void;
  function promptLogin(action: () => void, referral?: boolean): () => void;
  function promptLogin(
    action?: () => void,
    referral = true
  ): (() => void) | void {
    const navigateToLogin = () => {
      const loginPath = referral ? `/login?referral=${pathname}` : '/login';
      navigate(loginPath);
    };

    if (action) {
      return () => {
        if (!isSignedIn) {
          navigateToLogin();
        } else {
          action();
        }
      };
    }

    if (!isSignedIn) {
      navigateToLogin();
    }
  }

  return {
    currentUser,
    isSignedIn,
    promptLogin,
  };
}
